 export const materialTypes = [
  'Granite',
  'Limestone',
  'Sandstone',
  'Basalt',
  'Marble',
  'Unknown'
];

// Feature categories
export const featureCategories = {
  architectural: {
    label: 'Architectural Features',
    features: ['arch', 'ashlarWall', 'bevelBlock', 'column', 'niche', 'polygonalMasonry', 'polygonalWall', 'pyramid', 'terraces']
  },
  construction: {
    label: 'Construction & Tool Marks',
    features: ['clamps', 'damageHoles', 'lippedBlocks', 'nubs', 'pinchMark', 'sawCuts', 'scoopMarks', 'scrapeMarks', 'wedgeHoles']
  },
  cultural: {
    label: 'Cultural & Religious',
    features: ['hananPacha', 'hinduTemple', 'lingam', 'sarcophagus', 'statues']
  },
  natural: {
    label: 'Natural & Environmental',
    features: ['acousticProperties', 'astronomicalAlignments', 'cave', 'cartRuts', 'vitrification', 'waterFeatures']
  },
  artistic: {
    label: 'Artistic & Decorative',
    features: ['inscriptions', 'murals', 'stairstepmotif']
  }
};

// Function to add a new category
export const addCategory = (key, label) => {
  if (!featureCategories[key]) {
    featureCategories[key] = {
      label,
      features: []
    };
    return true;
  }
  return false;
};

// Function to remove a category
export const removeCategory = (key) => {
  if (featureCategories[key] && featureCategories[key].features.length === 0) {
    delete featureCategories[key];
    return true;
  }
  return false;
};

// Function to add a new feature to a category
export const addFeatureToCategory = (featureId, categoryKey) => {
  if (featureCategories[categoryKey] && !featureCategories[categoryKey].features.includes(featureId)) {
    featureCategories[categoryKey].features.push(featureId);
    updateFeaturesList();
  }
};

// Function to remove a feature from a category
export const removeFeatureFromCategory = (featureId, categoryKey) => {
  if (featureCategories[categoryKey]) {
    featureCategories[categoryKey].features = featureCategories[categoryKey].features.filter(
      id => id !== featureId
    );
    updateFeaturesList();
  }
};

// All available features (flattened for backward compatibility)
export const features = Object.values(featureCategories)
  .reduce((allFeatures, category) => [...allFeatures, ...category.features], []);

// Update features list after adding new features
export const updateFeaturesList = () => {
  Object.assign(features, Object.values(featureCategories)
    .reduce((allFeatures, category) => [...allFeatures, ...category.features], []));
};

export const eras = [
  'Pre-Dynastic',
  'Old Kingdom',
  'Middle Kingdom',
  'New Kingdom',
  'Late Period',
  'Greco-Roman',
  'Medieval',
  'Unknown'
];

export const researchStatuses = [
  'active',
  'needs_investigation',
  'at_risk',
  'stable'
];

export const countries = [
  'Egypt',
  'Greece',
  'Italy',
  'Turkey',
  'Peru',
  'Mexico',
  'China',
  'India',
  'Cambodia',
  'Japan'
];
